export default {
	activate: 'Activate',
	active: 'Active',
	add: 'Add',
	add_more_gift_item: 'Add Gift Item',
	address: 'Address',
	admin: 'Admin',
	admin_list_page: 'List of admins',
	admin_name: 'Admin Name',
	admin_register: 'Create an admin',
	admin_update: 'Edit admin',
	administrator_management: 'Administrator',
	all: 'All',
	available_permission: 'Available permission',
	banner: 'Banner',
	banner_list_page: 'List of banners',
	banner_management: 'Banner',
	banner_register: 'Create a banner',
	banner_update_page: 'Edit banner',
	birthday: 'Birthday',
	browse_file: 'Browse file',
	cancel: 'Cancel',
	categories: 'Categories',
	category: 'Category',
	category_code: 'Category Code',
	category_list_page: 'List of categories',
	category_register: 'Create a category',
	category_type: 'Category Type',
	category_update: 'Edit category',
	categorygift_list_page: 'List of category gift',
	categorygift_register: 'Create a category gift',
	categorygift_update: 'Edit category gift',
	change_password: 'Change password',
	choose_file: 'Choose file',
	choose_thumbnail: 'Choose thumbnail',
	city: 'City',
	code: 'Code',
	companies: 'Companies',
	company_code: 'Company code',
	company_list_page: 'List of Companies',
	company_register: 'Create an Company',
	company_update: 'Edit Company',
	confirm_password: 'Confirm Password',
	contact_list_page: 'List of contacts',
	contact_register: 'Create a contact',
	contact_update: 'Edit contact',
	content: 'Content',
	content_body: 'Content body',
	content_list_page: 'List of contents',
	content_management: 'Content',
	content_register: 'Create a content',
	content_title: 'Title',
	content_update: 'Edit content',
	content_url: 'Url',
	coupon_image: 'Coupon image',
	coupon_using_deadline: 'Coupon Using Deadline',
	coupon_using_guide: 'Coupon Using Guide',
	create_message_successfully: 'Create successfully',
	created_at: 'Created At',
	created_by: 'Created By',
	daily: 'daily',
	dashboard: 'Dashboard',
	dashboard_title_page: 'Dashboard',
	date: 'date',
	datetime: 'date time',
	deadline: 'Deadline',
	deadline_for_applying: 'Deadline for Applying',
	delete: 'Delete',
	delete_content: 'Are you sure to delete this item ?',
	delete_header: 'Delete confirmation',
	delete_message_error: 'Delete error',
	delete_message_successfully: 'Delete successfully',
	description: 'Description',
	discounted_price: 'Coupon Discount Amount',
	display_name: 'Display name',
	display_order: 'Display Order',
	display_time: 'Display time',
	display_type: 'Display type',
	duration: 'Duration',
	edit: 'Edit',
	email: 'Email',
	end_time: 'End Time',
	error_400_content: 'We are sorry but the page you are looking for was not found',
	error_401_content: 'We are sorry but you are not authorized to access this page',
	error_403_content: 'We are sorry but you do not have permission to access this page',
	error_404_content: 'We are sorry but the page you are looking for was not found',
	error_500_content: 'We are sorry but our server encountered an internal error',
	error_503_content: 'We are sorry but our service is currently not available',
	error_happened_please_try_again: 'Upload process got problem.',
	error_max_20_files_upload: 'The files may not be greater than 20 files',
	error_title: 'Oops… You just found an error page',
	export_csv: 'Export as CSV File',
	fax: 'Fax',
	file: 'file',
	first_name: 'First Name',
	freedial: 'Free dial',
	from: 'from',
	gender: 'Gender',
	gift_category_management: 'Gift Category',
	gift_item: 'Gift Item',
	gift_items: 'Gift Items',
	gift_using: 'Gift Using',
	gift_title: 'Gift Title',
	gift_using_history: 'Gift Using History',
	giveawaygift: 'Giveaway Gift',
	giveawaygift_list_page: 'List of give away gift',
	giveawaygift_register: 'Create a give away gift',
	giveawaygift_update: 'Edit give away gift',
	id: 'ID',
	image: 'Image',
	inactive: 'Inactive',
	is_active: 'Status',
	is_preview: 'Preview',
	last_name: 'Last Name',
	link_to_content: 'Link to content',
	link_to_url: 'Link to url',
	list: 'List',
	login: 'Log In',
	login_id: 'Login Id',
	login_password_placeholder: 'Password',
	login_remember_me: 'Remember Me',
	login_title: '<strong>Sign in</strong> to dashboard',
	login_username_placeholder: 'Username',
	login_welcome: 'Welcome, please use the form to sign-in.',
	login_wrong_username_password: 'Error!!! You have entered incorrect username or password.',
	logout: 'Log out',
	lottery_date: 'Lottery Date',
	lottery_drawing_date: 'Lottery Drawing Date',
	lottery_gift_category: 'Lottery Gift Category',
	lottery_gift_management: 'Lottery Gift',
	lotterygift: 'Lottery gift',
	lotterygift_list_page: 'List of lottery gift',
	lotterygift_register: 'Lottery Gift Add',
	lotterygift_update: 'Lottery Gift Edit',
	main_image: 'Main Image',
	media_list_page: 'Media List',
	media_title: 'Media title',
	message_body: 'Message Body',
	message_error: 'Error',
	message_success: 'Success',
	minimum_total_price: 'Min Limit for Applying Coupon',
	monthly: 'monthly',
	more_info: 'More info',
	name: 'Name',
	news: 'News',
	news_list_page: 'List of news',
	news_management: 'News',
	news_register: 'Create a new',
	news_title: 'Title',
	news_update: 'Edit new',
	news_url: 'Url',
	no: 'No',
	no_records_found: 'No records found.',
	normal_gift_management: 'Normal Gift',
	order: 'Order',
	password: 'Password',
	permission: 'Permission',
	permission_management: 'Permission',
	phone: 'Phone',
	please_choose_date: 'Please choose date',
	please_input: 'Please input',
	please_select_option: 'Please select option',
	post_list_page: 'List of posts',
	post_register: 'Create a post',
	post_update: 'Edit post',
	postal_code: 'Postal code',
	postcode: 'Postcode',
	prefecture: 'Prefecture',
	prefecture_code: 'Prefecture Code',
	prefecture_id: 'Prefecture',
	prefectures: 'Prefectures',
	preview_user: 'Preview user',
	preview_user_management: 'Preview User',
	public_duration: 'Public Duration',
	publish: 'Publish',
	publish_from: 'publish_from',
	publish_to: 'publish_to',
	rank: 'Rank',
	redeem_experation_date_for_first_lottery: 'Redeem Experation Date for First Lottery',
	redeem_experation_date_for_second_lottery: 'Redeem Experation Date for Second Lottery',
	registered_user: 'Registered User',
	remove: 'Remove',
	remove_all: 'Remove All',
	reset: 'Reset',
	retry: 'retry',
	review: 'Review',
	review_date: 'Review Date',
	review_deadline: 'Deadline for answer survey',
	review_list_page: 'List of Reviews',
	review_management: 'Review',
	reviews_image: 'Reviews Image',
	reviews_sending: 'Reviews Sending',
	role: 'Role',
	role_list_page: 'List of roles',
	role_register: 'Create a role',
	role_update: 'Edit role',
	roles: 'Role',
	save: 'Save',
	search: 'Search',
	search_by_user_number: 'Search by User Number',
	search_by_period: 'Search by monthly/daily',
	select: 'Select',
	select_category: 'Please select category',
	select_company: 'Please select company',
	select_content: 'Select Content',
	select_file_from_computer: 'Select files from computer',
	select_image: 'Please select image',
	select_prefecture: 'Please select prefecture',
	selected_permission: 'Selected permission',
	sending_date: 'Sending Date',
	sending_message: 'Sending Message',
	slug: 'Slug',
	sort: 'Sort',
	start_time: 'Start Time',
	status: 'Status',
	submit_add: 'Submit',
	submit_edit: 'Submit Edit',
	survey_management: 'Survey',
	take_me_home: 'Take me home',
	target_user_rank: 'Target User Rank',
	tel: 'Tel',
	thumbnail: 'Thumbnail',
	title: 'Title',
	to: 'to',
	total_users: 'Total users',
	type: 'Type',
	update_message_successfully: 'Update successfully',
	updated_at: 'Updated At',
	upload: 'upload',
	upload_message_error: 'Upload image error',
	upload_message_successfully: 'Upload image successfully',
	upload_process: 'Upload process',
	url: 'Homepage Url',
	user_list_page: 'List of users',
	user_register: 'Create an user',
	user_update: 'Edit user',
	username: 'Username',
	view: 'view',
	website: 'Website',
	winner_limitation: 'Winner Limitation',
	winning_notice_message: 'Winning Notice Message',
	winning_notice_sending: 'Winning Notice Sending',
	yes: 'Yes'
}



// WEBPACK FOOTER //
// ./src/languages/en.js